import React from 'react'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'

import Typography from 'components/atoms/Typography/Typography'

import './PostIt.scss'

function PostIt({ date, themeClasses, title, icon }) {
  const newDate = new Date(date)
  const monthNames = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]

  return (
    <div fluid className={`post-it card card-${themeClasses} px-3 py-4`}>
      {icon && <SVG className="icon mb-3" src={icon} preProcessor={(code) => code.replace(/filter=".*?"/g, '')} />}
      {<Typography cssClass="post-it__day title-bold-md">{newDate.getUTCDate()}</Typography>}
      {<Typography cssClass="post-it__month title-bold-md mb-2">{monthNames[newDate.getUTCMonth()]}</Typography>}
      {title && <Typography>{title}</Typography>}
    </div>
  )
}

PostIt.propTypes = {
  date: PropTypes.any,
  icon: PropTypes.string,
  themeClasses: PropTypes.string,
  title: PropTypes.string,
}

export default PostIt
